import Naluri from '~/common/api/naluri';
import {
  COMMON_GET_SPONSORS_LIST_BEGIN,
  COMMON_GET_SPONSORS_LIST_SUCCESS,
  COMMON_GET_SPONSORS_LIST_FAILURE,
  COMMON_GET_SPONSORS_LIST_DISMISS_ERROR,
} from './constants';
import { unionBy } from 'lodash';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getSponsorsList(args = {}) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: COMMON_GET_SPONSORS_LIST_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = Naluri.get(`/api/expert/channels/coupons`);
      doRequest.then(
        res => {
          dispatch({
            type: COMMON_GET_SPONSORS_LIST_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: COMMON_GET_SPONSORS_LIST_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetSponsorsListError() {
  return {
    type: COMMON_GET_SPONSORS_LIST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_GET_SPONSORS_LIST_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getSponsorsListPending: true,
        getSponsorsListError: null,
      };

    case COMMON_GET_SPONSORS_LIST_SUCCESS:
      // The request is success

      const couponList = action.data.coupons;
      let sponsorLogosList = state.sponsorsWithLogos;

      couponList.forEach(coupon => {
        if (coupon && coupon.sponsor) {
          sponsorLogosList = unionBy(sponsorLogosList, [coupon], 'sponsor');
        }
      });

      const foundSelfSponsored = sponsorLogosList.find(elem => elem.sponsor === 'Self-Sponsored');
      if (!foundSelfSponsored) {
        sponsorLogosList = [
          ...sponsorLogosList,
          {
            logo:
              'https://s3-ap-southeast-1.amazonaws.com/uploads.naluri.net/coupons/03816347-b33a-470e-8b4a-efc597bbc30c.png',
            sponsor: 'Self-Sponsored',
          },
        ];
      }

      sponsorLogosList = sponsorLogosList.sort((a, b) => {
        return a.sponsor.localeCompare(b.sponsor);
      });

      return {
        ...state,
        sponsorsWithLogos: sponsorLogosList,
        getSponsorsListPending: false,
        getSponsorsListError: null,
      };

    case COMMON_GET_SPONSORS_LIST_FAILURE:
      // The request is failed
      return {
        ...state,
        getSponsorsListPending: false,
        getSponsorsListError: action.data.error,
      };

    case COMMON_GET_SPONSORS_LIST_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getSponsorsListError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/getSponsorsList.js